export default {
  dinPro: 'DINPro',
  openSans: 'Open Sans',
  spaceMono: 'Space Mono',
  bold: 700,
  semibold: 600,
  regular: 400
};
